(() => {
  const init = () => document.querySelectorAll('.th-size-guide .sg-player').forEach(player => {
    if (player.dataset.ready) return;
    player.dataset.ready = 'true';
    const video = player.querySelector('video'), button = player.querySelector('.sg-play'), error = player.querySelector('.sg-video-error');
    if (!video || !button) return;
    button.hidden = false;
    video.controls = false;
    video.addEventListener('play', () => { video.controls = true; button.hidden = true; error.hidden = true; });
    video.addEventListener('ended', () => { button.hidden = false; button.disabled = false; });
    video.addEventListener('error', () => { error.hidden = false; button.hidden = false; button.disabled = false; });
    button.addEventListener('click', async () => {
      button.disabled = true; error.hidden = true;
      try { await video.play(); button.hidden = true; video.focus(); }
      catch { video.controls = true; error.hidden = false; button.hidden = false; }
      finally { button.disabled = false; }
    });
  });
  init(); document.addEventListener('shopify:section:load', init);
})();

(() => {
  const initFaq = () => {
    document.querySelectorAll('.th-size-guide .sg-faq details').forEach(details => {
      if (details.dataset.faqReady) return;
      details.dataset.faqReady = 'true';
      const summary = details.querySelector('summary');
      if (!summary) return;
      let animation = null;
      let expanded = details.open;
      summary.addEventListener('click', event => {
        if (event.target.closest('a, button, input, select, textarea')) return;
        event.preventDefault();
        expanded = !expanded;
        const from = details.getBoundingClientRect().height;
        if (animation) { animation.cancel(); animation = null; }
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
          details.open = expanded;
          details.style.overflow = '';
          return;
        }
        // Measure natural heights with the same borders and wrapping as the final state.
        details.open = expanded;
        const to = details.getBoundingClientRect().height;
        details.open = true;
        details.style.overflow = 'hidden';
        animation = details.animate(
          [{height: `${from}px`}, {height: `${to}px`}],
          {duration: 240, easing: 'cubic-bezier(.25,.1,.25,1)'}
        );
        animation.onfinish = () => {
          details.open = expanded;
          details.style.overflow = '';
          animation = null;
        };
      });
    });
  };
  initFaq();
  document.addEventListener('shopify:section:load', initFaq);
})();
